import { render, staticRenderFns } from "./CourseOutcomesSemesters.vue?vue&type=template&id=637955fa"
import script from "./CourseOutcomesSemesters.vue?vue&type=script&lang=js"
export * from "./CourseOutcomesSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports